import type { FaireProductEntity } from "../../entity_types/product";

export const p_p8nud99swa: FaireProductEntity = {
  token: "p_p8nud99swa",
  type: "product",
  name: "Sespe Pinecone 8 oz. Candle",
  brandToken: "b_ambzy6ccke",
  brandName: "Night Blooms Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/d1d2ee75e9d0ace044f3591686c89f7701f5feddc896cefbe559f6e457aa500c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2afe29c4831b0b19923be26024a54fef9a656fee79211df6f4bd2fb6bd3bf3f.png",
    "https://cdn.faire.com/fastly/a274b98d6ccfc005ebcdaddb9c82c8417454cb4d61f8755ff1a081b8dea8fa63.png",
  ],
  priceDollars: 21,
  description:
    "In the Sespe Wilderness, pine trees thrive and enlighten the senses. Sespe Pinecone has rich and festive notes, perfect for fall and winter. Cypress and zesty lemon peel fold into woodsy mid notes of evergreen and cedar. The rich base of fir, amber, and moss evokes fond memories of decorating a freshly-cut Christmas tree.\n\n• 100% natural soy wax\n• Non-toxic + phthalate free\n• Braided cotton wick\n• Ceramic screen printed labels (Reuse this glass)\n• Extended burn 50+ hours\n• Hand poured in Ojai, California",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:31.564Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
